import { FilterType } from '@/hooks/useLobbyUI';
import {
    CombineGameType,
    GameType as CommonGameType,
} from '@/models/games/enums/GameType';
import {
    AndarBaharIcon,
    BaccaratIcon,
    BlackjackIcon,
    DragonTigerIcon,
    PokDengIcon,
    RouletteIcon,
    SeDieIcon,
    SicboIcon,
} from './icon';
import { TeenPatti2020 } from './icon/TeenPatti2020';
type IconWrapperProps = {
    gameType: FilterType;
};
export const IconWrapper = ({ gameType }: IconWrapperProps) => {
    switch (gameType) {
        case CommonGameType.Baccarat:
            return <BaccaratIcon />;
        case CombineGameType.Poker:
        case CommonGameType.AndarBahar:
            return <AndarBaharIcon />;
        case CommonGameType.Blackjack:
            return <BlackjackIcon />;
        case CommonGameType.Dragon:
            return <DragonTigerIcon />;
        case CommonGameType.PokDeng:
            return <PokDengIcon />;
        case CombineGameType.Roulette:
        case CommonGameType.Roulette:
        case CommonGameType.UltraRoulette:
            return <RouletteIcon />;
        case CommonGameType.SeDie:
            return <SeDieIcon />;
        case CommonGameType.SicBo:
        case CommonGameType.ThaiHiLo:
        case CommonGameType.FishPrawnCrab:
        case CombineGameType.Dice:
            return <SicboIcon />;
        case CommonGameType.TeenPatti2020:
            return <TeenPatti2020 />;
        default:
            return <></>;
    }
};
